import { GovSkeleton } from '@gov-design-system-ce/react';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const RegisterSVListSkeleton = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(LocalizeNameSpaceTypes.Global);
	return (
		<div>
			{Array.from({ length: 3 }).map((_, index) => (
				<LayoutGap
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					gap="s"
					className="p-6">
					<GovSkeleton
						height="30px"
						width={generateRandomNumber(20, 60) + '%'}
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="24px"
						width={generateRandomNumber(40, 80) + '%'}
						aria-label={t('loading.wcag.processing')}
					/>
				</LayoutGap>
			))}
		</div>
	);
};

export const RegisterSVListAndFilterSkeleton = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<LayoutGap gap="m">
				<div className="flex justify-between gap-4 pb-3 border-b border-(--border-subtlest)">
					<GovSkeleton
						height="40px"
						width="330px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="40px"
						width="40px"
						aria-label={t('loading.wcag.processing')}
						className="ml-auto"
					/>
				</div>
				<div className="flex gap-8 mb-5!">
					<GovSkeleton
						height="32px"
						width="77px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="32px"
						width="76px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				<RegisterSVListSkeleton />
			</LayoutGap>
		</ContentLayout>
	);
};
